/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=e9dbf37e&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=e9dbf37e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dbf37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9dbf37e')) {
      api.createRecord('e9dbf37e', component.options)
    } else {
      api.reload('e9dbf37e', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=e9dbf37e&scoped=true", function () {
      api.rerender('e9dbf37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/SideBar.vue"
export default component.exports